import { connect } from 'react-redux';
import { loadSuggestions, clearSuggestions } from 'data/federalBasicPermits/federalBasicPermits.actions';
import FBPNAutocompleteContainer from './FBPNAutocompleteContainer';

const key = Symbol('FBPNAutocomplete');

const actions = {
  loadSuggestions: search => loadSuggestions(search, key),
  clearSuggestions: () => clearSuggestions(key)
};

function mapStateToProps(state) {
  return {
    ...state.federalBasicPermits[key]
  };
}

export default connect(mapStateToProps, actions)(FBPNAutocompleteContainer);
